import { FormattedMessage } from 'react-intl';
import { useClientConfig } from 'src/hooks/useClientConfig';
import AvatarAnimation from '../Chat/AvatarAnimation/AvatarAnimation';
import WidgetAvatar from '../Widget/WidgetAvatar/WidgetAvatar';

import './Loading.sass';

const Loading = ({ text = 'loading' }: { text?: string }) => {
	const client = useClientConfig();
	return (
		<div id="loading">
			{client ? <WidgetAvatar /> : <AvatarAnimation />}
			<FormattedMessage id={text} />
		</div>
	);
};

export default Loading;
